import { Injectable, ViewContainerRef, Compiler, NgModule, ComponentRef, ComponentFactory } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { CacheService } from "./cache.service";


@Injectable()
export class ComponentHelperService {
    constructor(
        private cache: CacheService
    ) { }

    cmpRef: ComponentRef<any> | null;
    compFactory: ComponentFactory<any> | null;
    //Inject a component in the viewContainer
    injectComponent(compiler: Compiler, containterRef: ViewContainerRef, componentToInject: any) {

        @NgModule({
            imports: [SharedModule],
            declarations: [componentToInject]
        })

        class DynamicModule { }

        compiler.compileModuleAndAllComponentsAsync(DynamicModule)
            .then((moduleWithFactories) => {
                this.compFactory = moduleWithFactories.componentFactories.find(x => x.componentType === componentToInject);

                //from v5 - slow and brings in a lot of code. This line of code affects ram performance negatively
                //https://angular.io/api/core/ReflectiveInjector
                //const injector = ReflectiveInjector.fromResolvedProviders([], containterRef.parentInjector);

                //Clearing current content before injecting new one
                // containterRef.clear();

                //containterRef.createComponent(compFactory, 0, injector);
                this.cmpRef = containterRef.createComponent(this.compFactory, 0);

                compiler.clearCache();
                moduleWithFactories = null;
            });
    }

    clearMemory() {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
        this.compFactory = null;
        this.cache.clearAll();
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/component-helper.service.ts